import type { QueryClient } from "@tanstack/react-query";
import type { EstimateChatMessage, ProposalOutcome } from "@rebuild/shared/models";
import { ESTIMATE_CHAT_KEYS } from "@/hooks/queries/estimate-chat";

// Accept and reject both answer with per-proposal outcomes; patch the proposals on the cached
// messages in place so cards update without a refetch.
export function applyProposalOutcomes(
  queryClient: QueryClient,
  estimateId: string,
  chatId: string,
  outcomes: ProposalOutcome[]): void {
  const byId = new Map(outcomes.map((o) => [o.proposalId, o]));
  queryClient.setQueryData<EstimateChatMessage[]>(ESTIMATE_CHAT_KEYS.messages(estimateId, chatId), (old = []) =>
    old.map((message) =>
      message.proposals
        ? {
            ...message,
            proposals: message.proposals.map((p) => {
              const outcome = byId.get(p.id);
              return outcome ? { ...p, status: outcome.status, errorMessage: outcome.errorMessage } : p;
            }),
          }
        : message,
    ),
  );
}
